import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

// The AppBar this sits inside is position="sticky" rather than "fixed", so the
// banner simply takes part in normal flow above the Toolbar and nothing needs a
// spacer offset the way red-panda-ui's fixed TopBar does.
export const BANNER_HEIGHT = 40;

const VersionUpdateBanner = ({ deployedVersion }) => (
  <Alert
    severity="warning"
    square
    icon={<SystemUpdateAltIcon fontSize="inherit" />}
    action={
      <Button
        color="inherit"
        size="small"
        onClick={() => window.location.reload()}
      >
        Reload
      </Button>
    }
    sx={{
      height: BANNER_HEIGHT,
      py: 0,
      borderRadius: 0,
      alignItems: "center",
    }}
  >
    Version {deployedVersion.split("+")[0]} is available.
  </Alert>
);

export default VersionUpdateBanner;
